import { RouteDescription } from "../types";

export function getRoutePermissions(route: RouteDescription, params: { id: any, mode: any }) {
  const modePermission = params?.id ? route.pageModePermissions?.[params?.mode] : {};

  return ({
    requiredPermissions: [
      ...(
        route.requiredPermissions
          ? (Array.isArray(route.requiredPermissions) ? route.requiredPermissions : [ route.requiredPermissions ])
          : []
      ),
      ...(
        modePermission?.requiredPermissions
          ? (Array.isArray(modePermission.requiredPermissions) ? modePermission.requiredPermissions : [ modePermission.requiredPermissions ])
          : []
      ),
    ],
    requiredOneOfPermissions: [
      ...(
        route.requiredOneOfPermissions
          ? (Array.isArray(route.requiredOneOfPermissions) ? route.requiredOneOfPermissions : [ route.requiredOneOfPermissions ])
          : []
      ),
      ...(
        modePermission?.requiredOneOfPermissions
          ? (Array.isArray(modePermission.requiredOneOfPermissions) ? modePermission.requiredOneOfPermissions : [ modePermission.requiredOneOfPermissions ])
          : []
      ),
    ],
  });
}